import { render } from "./GameInputView.vue?vue&type=template&id=3e963a00&scoped=true"
import script from "./GameInputView.vue?vue&type=script&lang=js"
export * from "./GameInputView.vue?vue&type=script&lang=js"

import "./GameInputView.vue?vue&type=style&index=0&id=3e963a00&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/aethonspel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e963a00"]])

export default __exports__